export default {
  fields: {
    sales: {
      label: 'Omzet',
    },
    gift_cards_sales: {
      label: 'Cadeaukaartomzet',
    },
    average_order_value: {
      label: 'Gemiddelde bestelwaarde',
    },
    savings: {
      label: 'Besparing op kosten van derden',
    },
    reservations: {
      label: 'Reserveringen',
    },
    sales_from_email: {
      label: 'Omzet via e-mail',
    },
    sales_from_google_seo: {
      label: 'Omzet via Google SEO',
    },
    sales_from_google_business_profile: {
      label: 'Omzet via Google Business',
    },
    sales_from_google_ads: {
      label: 'Omzet via Google Ads',
    },
    sales_from_flyers: {
      label: 'Omzet via flyers',
    },
    sales_from_social_media: {
      label: 'Omzet via social media',
    },
    sales_from_facebook_ads: {
      label: 'Omzet via Facebook Ads',
    },
    tips: {
      label: 'Fooien',
    },
    new_customers: {
      label: 'Nieuwe klanten',
    },
    returning_customers: {
      label: 'Terugkerende klanten',
    },
    new_visitors: {
      label: 'Nieuwe bezoekers',
    },
    new_followers: {
      label: 'Nieuwe volgers',
    },
    total_followers: {
      label: 'Totaal volgers',
    },
    delivered_messages: {
      label: 'Afgeleverde berichten',
    },
    average_open_rate: {
      label: 'Gemiddelde e-mailopenratio',
    },
    average_click_rate: {
      label: 'Gemiddelde klikratio',
    },
    website_visitors_from_email: {
      label: 'Websitebezoekers via e-mail',
    },
    sales_from_google_business: {
      label: 'Omzet via Google Business',
    },
    total_reservations: {
      label: 'Reserveringen',
    },
    website_visitors_from_google_seo: {
      label: 'Websiteklikken via Google SEO',
    },
    website_clicks_from_google_business: {
      label: 'Websiteklikken via Google Business',
    },
    website_visitors_from_google_ads: {
      label: 'Websiteklikken via Google Ads',
    },
    website_visitors_from_social_media: {
      label: 'Websiteklikken via social media',
    },
    calls_from_google_ads: {
      label: 'Oproepen via Google Ads',
    },
    directions_from_google_ads: {
      label: 'Routebeschrijvingen via Google Ads',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Social media',
    },
    flyer_orders_count: {
      label: 'Flyers',
    },
    email_orders_count: {
      label: 'E-mails',
    },
    other_orders_count: {
      label: 'Overige',
    },
    gmv: {
      label: 'GMV',
    },
    gift_cards_gmv: {
      label: 'Cadeaukaarten',
    },
    net_billed_revenue: {
      label: 'Gefactureerde omzet (netto)',
    },
    net_billed_revenue_subscription: {
      label: 'Gefactureerde abonnementsomzet',
    },
    net_billed_revenue_service_fee: {
      label: 'Gefactureerde servicekosten',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'Gefactureerde bezorgkosten omzet',
    },
    net_billed_revenue_other: {
      label: 'Gefactureerde servicekosten omzet',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'Gefactureerde bezorging - Doorberekend',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'Gefactureerde platformverwerkingskosten omzet',
    },
    gross_cash_income: {
      label: 'Contante inkomsten (Bruto)',
    },
    gross_cash_income_subscription: {
      label: 'Contante inkomsten uit abonnementen',
    },
    gross_cash_income_service_fee: {
      label: 'Contante inkomsten uit servicekosten',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Contante inkomsten uit bezorgkosten',
    },
    gross_cash_income_other: {
      label: 'Contante inkomsten uit servicetoeslagen',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Contante inkomsten uit doorberekende bezorgkosten',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Contante inkomsten uit platformverwerkingskosten',
    },
    net_cash_income: {
      label: 'Contante inkomsten (Netto)',
    },
    net_cash_income_subscription: {
      label: 'Contante inkomsten uit abonnementen',
    },
    net_cash_income_service_fee: {
      label: 'Contante inkomsten uit servicekosten',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Contante inkomsten uit bezorgkosten',
    },
    net_cash_income_other: {
      label: 'Contante inkomsten uit servicetoeslagen',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Contante inkomsten uit doorberekende bezorgkosten',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Contante inkomsten uit platformverwerkingskosten',
    },
    manual_connect_transfers: {
      label: 'Terugbetaald aan restaurants',
    },
    processing_fees: {
      label: 'Verwerkingskosten',
    },
    processing_fees_stripe: {
      label: 'Verwerkingskosten (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Verwerkingskosten (PayPal)',
    },
    rejected_orders: {
      label: 'Geweigerde bestellingen',
    },
    rejected_orders_amount: {
      label: 'Bedrag geweigerde bestellingen',
    },
    rejected_orders_count: {
      label: 'Aantal geweigerde bestellingen',
    },
    rejected_orders_rate: {
      label: 'Percentage geweigerde bestellingen',
    },
    rejected_orders_rate_breakdown: {
      label: 'Uitsplitsing geweigerde bestellingen %',
    },
    orders: {
      label: 'Bestellingen',
    },
    total_orders: {
      label: 'Totaal bestellingen',
    },
    pickup_orders_rate: {
      label: 'Percentage afhaalbestellingen',
    },
    delivery_orders_rate: {
      label: 'Percentage bezorgbestellingen',
    },
    other_orders_rate: {
      label: 'Percentage overige bestellingen',
    },
    customers: {
      label: 'Totaal klanten',
    },
    customers_auth_state: {
      label: 'Authenticatiestatus klanten',
    },
    website_reservations: {
      label: 'Website reserveringen',
    },
    google_reservations: {
      label: 'Google reserveringen',
    },
    companies: {
      label: 'Bedrijven',
    },
    live_companies: {
      label: 'Actieve restaurants',
    },
    live_companies_percentage: {
      label: 'Percentage actieve restaurants',
    },
    setup_packages_breakdown: {
      label: 'Installatiepakketten',
    },
    setup_packages_billing_mode_breakdown: {
      label: 'Installatiepakketten per factureringsbron',
    },
    crossed_sales_level_this_month: {
      label: 'Omzetdrempel bereikt deze maand',
    },
    crossed_sales_level_total: {
      label: 'Omzetdrempel bereikt totaal',
    },
    crossed_sales_level_percentage: {
      label: 'Percentage omzetdrempel bereikt',
    },
    has_delivery: {
      label: 'Eigen bezorging',
    },
    has_only_pickup: {
      label: 'Alleen afhalen',
    },
    has_storefront: {
      label: 'Heeft webshop',
    },
    has_storefront_percentage: {
      label: 'Percentage webshop',
    },
    use_external_delivery: {
      label: 'Externe bezorging',
    },
    crossed_sales: {
      label: '{{value}} verkopen bereikt',
    },
    restaurant_partners: {
      label: 'Restaurantpartners',
    },
    registered_restaurants: {
      label: 'Geregistreerde restaurants',
    },
    signed_restaurants: {
      label: 'Ondertekende restaurants',
    },
    use_reservations: {
      label: 'Reserveringen gebruiken',
    },
    number: {
      label: 'Aantal',
    },
    restaurants_percentage: {
      label: 'Percentage restaurants',
    },
    crossed_sales_level: {
      label: 'Omzetdrempel bereikt',
    },
    order_method: {
      label: 'Bestelmethode',
    },
    own_delivery: {
      label: 'Eigen bezorging',
    },
    only_pickup: {
      label: 'Alleen afhalen',
    },
    storefront: {
      label: 'Webshop',
    },
    sales_tiers: {
      label: 'Omzetniveaus',
    },
    new_pricing_adoption_rate: {
      label: 'Adoptiegraad nieuwe prijsstelling',
    },
    mobile_app_attach_rate: {
      label: 'Koppelingsgraad mobiele app',
    },
    mobile_app_setup_fee_breakdown: {
      label: 'Gekozen installatiekosten mobiele app',
    },
    first_delivery: {
      label: 'Uber (Eerste bezorging)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Aantal bezorgoffertes',
    },
    deliveries_count: {
      label: 'Aantal bezorgingen',
    },
    delivery_conversion: {
      label: 'Bezorgconversieratio',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Bezorgoffertes per aanbieder',
    },
    deliveries_provider_breakdown: {
      label: 'Bezorgingen per aanbieder',
    },
    delivery_distance_breakdown: {
      label: 'Uitsplitsing bezorgafstand',
    },
    total_delivered: {
      label: 'Afgeleverde berichten',
    },
    website_visitors_from_google_business_profile: {
      label: 'Websitekliks via Google Business',
    },
    google_business_impressions: {
      label: 'Vertoningen via Google Business',
    },
    google_business_website_clicks: {
      label: 'Websitekliks via Google Business',
    },
    google_ads_impressions: {
      label: 'Vertoningen Google Ads',
    },
    google_ads_clicks: {
      label: 'Kliks Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Telefoongesprekken Google Ads',
    },
    google_ads_directions: {
      label: 'Routebeschrijvingen Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: 'Gem. absoluut top-vertoningspercentage Google Ads',
    },
    google_ads_average_cpc: {
      label: 'Gem. kosten per klik Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Gem. conversieratio uit interacties Google Ads',
    },
    website_visits: {
      label: 'Websitebezoeken',
    },
    website_visitors: {
      label: 'Websitebezoekers',
    },
    companies_with_activated_reservations: {
      label: 'Restaurants met geactiveerde reserveringen',
    },
    online_orders_count: {
      label: 'Online bestellingen',
    },
    cash_orders_count: {
      label: 'Online bestellingen',
    },
    cash_sales: {
      label: 'Contante verkopen',
    },
    online_sales: {
      label: 'Online verkopen',
    },
    payouts: {
      label: 'Uitbetalingen',
    },
    last_payout_amount: {
      label: 'Laatste uitbetaling',
    },
    pending_payout_amount: {
      label: 'Onderweg',
    },
    future_payout_amount: {
      label: 'Beschikbaar voor toekomstige uitbetalingen',
    },
    mobile_app_average_order_value: {
      label: 'AOV via app',
    },
    mobile_app_gmv: {
      label: 'Totale verkopen via app',
    },
    mobile_app_gmv_percentage: {
      label: 'Omzet % via app',
    },
    mobile_app_downloads: {
      label: 'Totaal app-downloads',
    },
    mobile_app_orders_count: {
      label: 'Totale bestellingen via app',
    },
    net_billed_revenue_gift_cards: {
      label: 'Gefactureerde cadeaukaarten omzet',
    },
    gross_cash_income_gift_cards: {
      label: 'Contante inkomsten uit cadeaukaarten',
    },
    net_cash_income_gift_cards: {
      label: 'Contante inkomsten uit cadeaukaarten',
    },
    platform_processing_fees: {
      label: 'Platformverwerkingskosten',
    },
  },
};
